
// // export default AIVisibilityPage;
// // src/components/BrandAudit/Step9_AIVisibility.jsx
// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { auditAPI } from '../../services/api';
// import { GoogleGenerativeAI } from '@google/generative-ai';

// const CACHE_TTL = 24 * 60 * 60 * 1000;
// const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY || '';

// const platformConfig = {
//   chatgpt:    { name: 'ChatGPT',    icon: '🤖', color: '#10a37f' },
//   gemini:     { name: 'Gemini',     icon: '✨', color: '#4285f4' },
//   claude:     { name: 'Claude',     icon: '🔮', color: '#D4692A' },
// };

// // ─── Generate 10 LLM questions via backend ────────────────────────────────
// const generateLLMQuestions = async (brand, keywords, city) => {
//   const cacheKey = `llmQuestions_${brand}_${city}_${keywords.slice(0, 3).join('_')}`.replace(/\s/g, '');
  
//   // Check cache first (reuse for 24h)
//   try {
//     const cached = localStorage.getItem(cacheKey);
//     if (cached) {
//       const { ts, questions } = JSON.parse(cached);
//       if (Date.now() - ts < CACHE_TTL && questions?.length) {
//         console.log('⚡ LLM questions cache hit');
//         return questions;
//       }
//     }
//   } catch {}

//   try {
//     console.log("Brand Name, keywords",JSON.stringify({ brand, keywords, city: city || '' }))
//     const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/generate-questions`, {
//       method: 'POST',
//       headers: { 
//         'Content-Type': 'application/json',
//         'X-Secret-Token': process.env.REACT_APP_SECRET_TOKEN || '',   // ← ADD THIS
//       },
//       body: JSON.stringify({ brand, keywords, city: city || '' }),
//     });
//     if (!res.ok) throw new Error(`HTTP ${res.status}`);
//     const { questions } = await res.json();
//     if (questions?.length) {
//       localStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), questions }));
//       return questions;
//     }
//   } catch (e) {
//     console.warn('LLM question generation failed, using template fallback:', e);
//   }
//   return null; // null = backend will use template fallback
// };

// // ─── Gemini API wrapper ────────────────────────────────────────────────────
// const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);
// const callGemini = async (prompt) => {
//   if (!GEMINI_API_KEY) throw new Error('REACT_APP_GEMINI_API_KEY not set in .env');
//   try {
//     const model = genAI.getGenerativeModel({ model: 'gemini-2.5-flash' });
//     const result = await model.generateContent(prompt);
//     const response = await result.response;
//     return response.text();
//   } catch (error) {
//     console.error('Gemini SDK error:', error);
//     throw new Error('Gemini API request failed');
//   }
// };

// // ─── AI Insight Box ────────────────────────────────────────────────────────
// const INSIGHT_TTL = 24 * 60 * 60 * 1000;

// const AIInsightBox = ({ prompt, cacheKey, title = 'AI Insight', autoGenerate = true }) => {
//   const [aiText, setAiText] = useState('');
//   const [aiLoading, setAiLoading] = useState(false);
//   const [aiError, setAiError] = useState('');
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [isPaused, setIsPaused] = useState(false);
//   const utteranceRef = useRef(null);
//   const generatedRef = useRef(false);

//   useEffect(() => () => window.speechSynthesis.cancel(), []);

//   useEffect(() => {
//     if (!cacheKey) return;
//     generatedRef.current = false; // reset so new cacheKey can trigger generation
//     const loadOrGenerate = async () => {
//       try {
//         const cached = localStorage.getItem(`ai_insight_${cacheKey}`);
//         if (cached) {
//           const { ts, text } = JSON.parse(cached);
//           if (Date.now() - ts < INSIGHT_TTL && text) {
//             setAiText(text);
//             return;
//           }
//         }
//       } catch {}
//       if (autoGenerate && !generatedRef.current) {
//         generatedRef.current = true;
//         await generate();
//       }
//     };
//     loadOrGenerate();
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [cacheKey, prompt]);

//   const generate = async () => {
//     if (!prompt) return;
//     setAiLoading(true);
//     setAiError('');
//     try {
//       const text = await callGemini(prompt);
//       setAiText(text);
//       if (cacheKey) {
//         localStorage.setItem(`ai_insight_${cacheKey}`, JSON.stringify({ ts: Date.now(), text }));
//       }
//     } catch (e) {
//       setAiError('Could not generate insight. Check your API key.');
//       console.error(e);
//     } finally {
//       setAiLoading(false);
//     }
//   };

//   const togglePlayback = () => {
//     const synth = window.speechSynthesis;
//     if (isPlaying) {
//       synth.pause();
//       setIsPlaying(false);
//       setIsPaused(true);
//     } else {
//       if (isPaused && synth.paused) {
//         synth.resume();
//         setIsPlaying(true);
//         setIsPaused(false);
//       } else {
//         synth.cancel();
//         const utterance = new SpeechSynthesisUtterance(aiText.replace(/<[^>]*>/g, ''));
//         utterance.lang = 'en-IN';
//         utterance.onend = () => { setIsPlaying(false); setIsPaused(false); };
//         utterance.onerror = () => { setIsPlaying(false); setIsPaused(false); };
//         utteranceRef.current = utterance;
//         synth.speak(utterance);
//         setIsPlaying(true);
//         setIsPaused(false);
//       }
//     }
//   };

//   return (
//     <div className="insight-box" style={{ marginTop: 20 }}>
//       <div className="insight-header">
//         <div className="insight-title">
//           <svg viewBox="0 0 24 24" width="20" height="20">
//             <path d="M12 2a7 7 0 00-7 7c0 2.6 1.4 4.9 3.5 6.2V17a1 1 0 001 1h5a1 1 0 001-1v-1.8C17.6 13.9 19 11.6 19 9a7 7 0 00-7-7zm2 17h-4v1a1 1 0 001 1h2a1 1 0 001-1v-1z" />
//           </svg>
//           {title}
//         </div>
//         {aiText && !aiLoading && (
//           <button className="play-btn" onClick={togglePlayback}>
//             <svg viewBox="0 0 24 24" width="12" height="12">
//               {isPlaying
//                 ? <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
//                 : <path d="M8 5v14l11-7z" />}
//             </svg>
//             {isPlaying ? 'Pause' : 'Play'}
//           </button>
//         )}
//       </div>
//       {aiLoading && <div style={{ fontSize: 13, color: '#6B4FA0' }}>Generating AI insight…</div>}
//       {aiError && !aiLoading && <div style={{ fontSize: 12, color: '#c62828' }}>{aiError}</div>}
//       {aiText && !aiLoading && <div className="insight-text" style={{ marginTop: 8 }}>{aiText}</div>}
//       {!aiText && !aiLoading && !aiError && (
//         <div style={{ fontSize: 12, color: '#aaa', fontStyle: 'italic' }}>AI insight will appear here shortly.</div>
//       )}
//     </div>
//   );
// };

// // ── Helper to generate overall insight prompt ─────────────────────────────
// const buildOverallPrompt = (brandName, keyword, platformsData) => {
//   const getMentions = (p) => p.questions?.filter(q => q.mentioned).length || 0;
//   const getTotal = (p) => p.questions?.length || 5;

//   const chatgpt = platformsData.find(p => p.id === 'chatgpt') || {};
//   const gemini  = platformsData.find(p => p.id === 'gemini') || {};
//   const claude  = platformsData.find(p => p.id === 'claude') || {};

//   const avgScore = Math.round(
//     platformsData.reduce((sum, p) => sum + p.overallScore, 0) / platformsData.length
//   );

//   return `You are a senior digital strategist specialising in AI search visibility.
// Professional, business-appropriate language. No bullet points. Maximum 3 sentences.

// Brand: ${brandName}
// Keyword: ${keyword}

// ChatGPT Visibility Score: ${chatgpt.overallScore || 0}/100  |  Mentions: ${getMentions(chatgpt)}/${getTotal(chatgpt)}
// Gemini Visibility Score: ${gemini.overallScore || 0}/100  |  Mentions: ${getMentions(gemini)}/${getTotal(gemini)}
// Claude Visibility Score: ${claude.overallScore || 0}/100  |  Mentions: ${getMentions(claude)}/${getTotal(claude)}
// Composite AI Visibility Score: ${avgScore}/100

// Provide a professional cross-platform assessment of this brand's AI search visibility for the specified keyword. Identify the platform representing the highest priority for improvement. Conclude with the strategic implication of the current composite score as AI-driven discovery increasingly shapes purchasing behaviour.`;
// };

// // ─────────────────────────────────────────────────────────────────────────
// // Main Component
// // ─────────────────────────────────────────────────────────────────────────
// const AIVisibilityPage = ({
//   brandName,
//   pillarKeywords: propsKeywords,
//   location,
//   onContinue,
// }) => {
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [pillarKeywords, setPillarKeywords] = useState([]);
//   const [selectedKeyword, setSelectedKeyword] = useState('');
//   const [aiData, setAiData] = useState(null);
//   const [activeTab, setActiveTab] = useState('chatgpt');
//   const [llmQuestions, setLlmQuestions] = useState(null);
//   const isFetching = useRef(false);
//   const llmQuestionsRef = useRef(null);       // ← ADD
//   const auditFiredRef = useRef(false);
  
//   // ── FIX 1: Properly initialise keywords from props OR localStorage ────────
//   // Props keywords are used when available (e.g. PublicAuditView passes `tags`).
//   // If props are empty, fall back to localStorage.
//   // useEffect(() => {
//   //   const fromProps = Array.isArray(propsKeywords) ? propsKeywords.filter(Boolean) : [];

//   //   if (fromProps.length > 0) {
//   //     setPillarKeywords(fromProps);
//   //     setSelectedKeyword(prev => prev || fromProps[0]);
//   //     return;
//   //   }

//   //   // Fall back to localStorage
//   //   try {
//   //     const stored = localStorage.getItem('auditFormData');
//   //     if (stored) {
//   //       const formData = JSON.parse(stored);
//   //       const kw = (formData.pillarKeywords || []).filter(Boolean);
//   //       if (kw.length) {
//   //         setPillarKeywords(kw);
//   //         setSelectedKeyword(prev => prev || kw[0]);
//   //       } else {
//   //         setError('No pillar keywords found. Please complete step 1 first.');
//   //         setLoading(false);
//   //       }
//   //     } else {
//   //       setError('No audit data found. Please start the audit from step 1.');
//   //       setLoading(false);
//   //     }
//   //   } catch {
//   //     setError('Failed to load audit data.');
//   //     setLoading(false);
//   //   }
//   // // Re-run only when propsKeywords identity changes (array ref)
//   // // eslint-disable-next-line react-hooks/exhaustive-deps
//   // }, [JSON.stringify(propsKeywords)]);
//   useEffect(() => {
//   const fromProps = Array.isArray(propsKeywords) ? propsKeywords.filter(Boolean) : [];
//   let resolvedKeywords = [];
//   let resolvedCity = location || '';

//   if (fromProps.length > 0) {
//     resolvedKeywords = fromProps;
//     setPillarKeywords(fromProps);
//     setSelectedKeyword(prev => prev || fromProps[0]);
//   } else {
//     try {
//       const stored = localStorage.getItem('auditFormData');
//       if (stored) {
//         const formData = JSON.parse(stored);
//         const kw = (formData.pillarKeywords || []).filter(Boolean);
//         if (kw.length) {
//           resolvedKeywords = kw;
//           if (!resolvedCity) resolvedCity = formData.locations?.[0]?.city || '';
//           setPillarKeywords(kw);
//           setSelectedKeyword(prev => prev || kw[0]);
//         } else {
//           setError('No pillar keywords found. Please complete step 1 first.');
//           setLoading(false);
//         }
//       } else {
//         setError('No audit data found. Please start the audit from step 1.');
//         setLoading(false);
//       }
//     } catch {
//       setError('Failed to load audit data.');
//       setLoading(false);
//     }
//   }

//   // ── NEW: Generate 10 LLM questions as soon as keywords are known ──────
//   if (resolvedKeywords.length && brandName) {
//     generateLLMQuestions(brandName, resolvedKeywords, resolvedCity)
//       .then(qs => {
//         if (qs) setLlmQuestions(qs);
//       });
//   }
// // eslint-disable-next-line react-hooks/exhaustive-deps
// }, [JSON.stringify(propsKeywords)]);


//   const cleanDomain = (url) =>
//     url?.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();

//   const fetchAIVisibility = useCallback(async (forceRefresh = false, keyword = selectedKeyword) => {
//     if (!keyword || !brandName) return;

//     const stored = localStorage.getItem('auditFormData');
//     let websiteUrl = '', locationCity = location || '';
//     try {
//       if (stored) {
//         const formData = JSON.parse(stored);
//         websiteUrl = formData.websiteUrl || '';
//         if (!locationCity) locationCity = formData.locations?.[0]?.city || '';
//       }
//     } catch {}

//     const domain = cleanDomain(websiteUrl) || brandName.toLowerCase().replace(/\s/g, '');
//     const brandSlug = brandName.toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 20);
//     const cacheKey = `aiVisibility_${domain}_${brandSlug}_${keyword}`;
//     const now = Date.now();

//     if (!forceRefresh) {
//       const cached = localStorage.getItem(cacheKey);
//       if (cached) {
//         try {
//           const { timestamp, data } = JSON.parse(cached);
//           if (now - timestamp < CACHE_TTL) {
//             setAiData(data);
//             setLoading(false);
//             return;
//           }
//         } catch {}
//       }
//     }

//     if (isFetching.current && !forceRefresh) return;
//     isFetching.current = true;
//     setLoading(true);
//     setError('');

//     try {
//       const response = await auditAPI.aiVisibility({
//         domain,
//         platforms: ['chatgpt', 'gemini', 'claude'],
//         keywords: [keyword],
//         brand: brandName,
//         competitors: [],
//         location: locationCity,
//         industry: '',
//         force_refresh: forceRefresh,
//         llm_questions: llmQuestionsRef.current || undefined,   // ref is always current
//       });

//       const result = response?.data?.data || response?.data || response;
//       if (!result) throw new Error('Empty response');

//       const platformData = result.platform_results || {};
//       const summaryData  = result.summary || {};

//       const platformsArray = Object.entries(platformData).map(([key, p]) => ({
//         id: key,
//         name: platformConfig[key]?.name || key,
//         icon: platformConfig[key]?.icon || '?',
//         borderColor: platformConfig[key]?.color || '#6b7280',
//         overallScore: p.overall_score || 0,
//         visible: p.visible || 'Not Found',
//         badgeClass: p.visible === 'Visible' ? 'aiv-y' : (p.visible === 'Partial' ? 'aiv-p' : 'aiv-n'),
//         subScores: {
//           brandMentioned: p.mention_pts || 0,
//           avgPosition:    p.position_pts || 0,
//           sentiment:      p.sentiment_pts || 0,
//           accuracy:       p.accuracy_pts || 0,
//         },
//         questions: (p.question_results || []).map((q) => ({
//           id:        q.q_index,
//           text:      q.question,
//           mentioned: q.mentioned || false,
//           rank:      q.rank || null,
//           sentiment: q.tone ? q.tone.charAt(0).toUpperCase() + q.tone.slice(1) : 'Neutral',
//           snippet:   q.snippet || '',
//         })),
//       }));

//       const totalQuestions = summaryData.total_questions ||
//         (platformsArray[0]?.questions?.length || 5) * platformsArray.length;
//       const yourMentions = platformsArray.reduce(
//         (sum, p) => sum + (p.questions?.filter(q => q.mentioned).length || 0), 0
//       );
//       const avgVisibilityScore = summaryData.brand_avg_score ||
//         platformsArray.reduce((s, p) => s + p.overallScore, 0) / Math.max(platformsArray.length, 1);

//       const summary = {
//         aiVisibilityScore:    Math.round(avgVisibilityScore),
//         platformsVisibleOn:   platformsArray.filter(p => ['Visible', 'Partial'].includes(p.visible)).length,
//         visiblePlatforms:     platformsArray.filter(p => p.visible === 'Visible').map(p => p.name),
//         aiShareOfVoice:       totalQuestions > 0 ? `${Math.round((yourMentions / totalQuestions) * 100)}%` : '0%',
//         avgMentionPosition:   summaryData.avg_mention_position || '—',
//         platformsTested:      platformsArray.length,
//         lastChecked:          new Date().toLocaleString(),
//         keyword,
//       };

//       const finalData = { summary, platforms: platformsArray, totalResponses: totalQuestions };
//       localStorage.setItem(cacheKey, JSON.stringify({ domain, keyword, timestamp: Date.now(), data: finalData }));
//       setAiData(finalData);
//     } catch (err) {
//       console.error(err);
//       setError(err.message || 'Failed to fetch AI visibility data.');
//     } finally {
//       isFetching.current = false;
//       setLoading(false);
//     }
//   }, [brandName, location, selectedKeyword]);

// // Keep ref in sync with state so fetchAIVisibility always reads latest value
// useEffect(() => {
//   llmQuestionsRef.current = llmQuestions;
//   console.log('🔁 llmQuestionsRef updated:', llmQuestions?.length, 'questions');
// }, [llmQuestions]);

//   // Fires audit once questions are ready, or after 4s timeout
// useEffect(() => {
//   if (!selectedKeyword || aiData || auditFiredRef.current) return;

//   if (llmQuestions) {
//     // Questions already here — fire immediately
//     auditFiredRef.current = true;
//     fetchAIVisibility(false, selectedKeyword);
//     return;
//   }

//   // Wait up to 4s for questions, then fire anyway as fallback
//   const timer = setTimeout(() => {
//     if (!auditFiredRef.current) {
//       console.warn('⏱ LLM questions not ready after 4s — using template fallback');
//       auditFiredRef.current = true;
//       fetchAIVisibility(false, selectedKeyword);
//     }
//   }, 8000);

//   return () => clearTimeout(timer);
// }, [selectedKeyword, aiData]);

// // Fires the moment llmQuestions land (if audit hasn't started yet)
// useEffect(() => {
//   if (!llmQuestions || !selectedKeyword || aiData || auditFiredRef.current) return;
//   auditFiredRef.current = true;
//   fetchAIVisibility(false, selectedKeyword);
// }, [llmQuestions]);


//   // ── FIX 1b: keyword change handler — ensure dropdown is fully interactive ─
//   const handleKeywordChange = (e) => {
//     const kw = e.target.value;
//     setSelectedKeyword(kw);
//     setAiData(null);
//     isFetching.current = false;
//     auditFiredRef.current = false;
//     setTimeout(() => fetchAIVisibility(false, kw), 0);
//   };

//   const activePlatform      = aiData?.platforms?.find(p => p.id === activeTab) || null;
//   const activePlatformScore = activePlatform?.overallScore || 0;

//   if (loading) {
//     return (
//       <div className="card" id="card-9">
//         <div className="eyebrow">AI Visibility</div>
//         <h2 className="ctitle">AI Search Visibility</h2>
//         <p className="cdesc">Is your brand being recommended by AI tools when customers search for your keywords? Here's the full picture.</p>
//         <div className="ai-fetch show"><div className="spinner" /><span>Checking AI visibility across ChatGPT, Gemini, Claude</span></div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="card" id="card-9">
//         <div className="eyebrow">AI Visibility</div>
//         <h2 className="ctitle">AI Search Visibility</h2>
//         <p className="cdesc" style={{ color: '#C0392B' }}>{error}</p>
//         <button className="btn" onClick={() => fetchAIVisibility(true)}>Retry</button>
//       </div>
//     );
//   }

//   if (!aiData?.platforms) {
//     return (
//       <div className="card" id="card-9">
//         <div className="eyebrow">AI Visibility</div>
//         <h2 className="ctitle">AI Search Visibility</h2>
//         <p className="cdesc">No AI visibility data available.</p>
//       </div>
//     );
//   }

//   const { summary, platforms } = aiData;

//   return (
//     <div className="card" id="card-9">
//       <div className="eyebrow">AI Visibility</div>
//       <h2 className="ctitle">AI Search Visibility</h2>
//       <p className="cdesc">Is your brand being recommended by AI tools when customers search for your keywords? Here's the full picture.</p>

//       {/*
//         ── FIX 2: PDF keyword context label ──────────────────────────────────
//         In print mode the dropdown is hidden (.kw-select { display:none }),
//         so we show a static label instead so the PDF reader knows which
//         keyword the data belongs to.
//       */}
//       <style>{`
//         @media print {
//           .ai-kw-print-label { display: block !important; }
//         }
//         .ai-kw-print-label { display: none; }
//       `}</style>

//       <div className="ai-wrap show">
//         {/* ── Keyword selector (interactive, never readOnly) ── */}
//         <div className="ai-kw-row">
//           <span className="ai-kw-label">Keyword</span>
//           {/* FIX 1: plain <select> — no readOnly, no disabled, pointer-events auto */}
//           <select
//             className="kw-select"
//             value={selectedKeyword}
//             onChange={handleKeywordChange}
//             style={{ pointerEvents: 'auto', cursor: 'pointer' }}
//           >
//             {pillarKeywords.map(kw => (
//               <option key={kw} value={kw}>{kw}</option>
//             ))}
//           </select>
//           {activePlatform?.questions?.length > 0 && (
//             <span style={{ fontSize: 11, color: 'var(--muted)', marginLeft: 8 }}>
//               {activePlatform.questions.length} questions tested
//             </span>
//           )}
//         </div>

//         {/* FIX 2: Shown only in PDF — static keyword label replacing hidden dropdown */}
//         <div className="ai-kw-print-label" style={{
//           fontSize: 13, fontWeight: 600, color: '#6B4FA0',
//           marginBottom: 12, padding: '6px 12px',
//           background: 'rgba(107,79,160,0.07)',
//           borderRadius: 8, display: 'none',
//         }}>
//           Keyword: <strong>{selectedKeyword}</strong>
//         </div>

//         {/* Score cards per platform */}
//         <div className="ai-score-row">
//           {platforms.map(p => (
//             <div key={p.id} className="ai-score-card" style={{ borderTop: `2px solid ${p.borderColor}` }}>
//               <div className="ai-tool-logo">{p.icon}</div>
//               <div className="ai-tool-name">{p.name}</div>
//               <div className="ai-vis-score" style={{ color: p.borderColor }}>{p.overallScore}</div>
//               <div className="ai-mention-count">
//                 {p.questions?.filter(q => q.mentioned).length || 0}/{p.questions?.length || 5} mentions
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Platform tabs */}
//         <div className="ai-tabs">
//           {['chatgpt', 'gemini', 'claude'].map(pid => {
//             const p = platforms.find(p => p.id === pid);
//             if (!p) return null;
//             return (
//               <button
//                 key={pid}
//                 className={`ai-tab ${activeTab === pid ? 'active' : ''}`}
//                 onClick={() => setActiveTab(pid)}
//               >
//                 <span style={{ fontSize: 14 }}>{p.icon}</span> {p.name}
//               </button>
//             );
//           })}
//         </div>

//         {/* Visibility score bar */}
//         <div className="ai-vis-bar-wrap">
//           <span className="ai-vis-bar-label">{activePlatform?.name} · AI Visibility Score</span>
//           <div className="ai-vis-bar-track">
//             <div className="ai-vis-bar-fill" style={{ width: `${activePlatformScore}%` }} />
//           </div>
//           <span className="ai-vis-score-num">{activePlatformScore}/100</span>
//         </div>

//         {/* Prompts list */}
//         <div className="prompt-list">
//           {activePlatform?.questions.map((q, i) => (
//             <div key={i} className="prompt-row">
//               <div className="prompt-top">
//                 <div className="prompt-num">{i + 1}</div>
//                 <div className="prompt-text">"{q.text}"</div>
//               </div>
//               <div className="prompt-meta">
//                 <span className={`pmeta-badge ${q.mentioned ? 'pmeta-mentioned' : 'pmeta-not'}`}>
//                   {q.mentioned ? '✓ Mentioned' : '✗ Not Mentioned'}
//                 </span>
//                 {q.mentioned && q.rank     && <span className="pmeta-pos">Position #{q.rank}</span>}
//                 {q.mentioned && q.sentiment && <span className={`pmeta-sent-${q.sentiment.toLowerCase()}`}>{q.sentiment}</span>}
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Overall AI Insight */}
//         <AIInsightBox
//           title="Overall AI Visibility Insight"
//           cacheKey={`ai_overall_${selectedKeyword}_${brandName.replace(/\s/g, '')}`}
//           prompt={buildOverallPrompt(brandName, selectedKeyword, platforms)}
//           autoGenerate={!!GEMINI_API_KEY}
//         />
//       </div>

//       <button className="btn" onClick={onContinue} style={{ marginTop: 20 }}>
//        Unlock Your Score Status
//         <svg viewBox="0 0 24 24" fill="white">
//           <path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z"/>
//         </svg>
//       </button>
//     </div>
//   );
// };

// export default AIVisibilityPage;

// src/components/BrandAudit/Step9_AIVisibility.jsx
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { auditAPI } from '../../services/api';
import { GoogleGenerativeAI } from '@google/generative-ai';

const CACHE_TTL = 24 * 60 * 60 * 1000;
const INSIGHT_TTL = 24 * 60 * 60 * 1000;
const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY || '';

const PLATFORM_ORDER = ['chatgpt', 'gemini', 'claude', 'perplexity'];

const platformConfig = {
  chatgpt:     { name: 'ChatGPT',    icon: '🤖', color: '#10a37f' },
  gemini:      { name: 'Gemini',     icon: '✨', color: '#4285f4' },
  claude:      { name: 'Claude',     icon: '🔮', color: '#2563eb' },
  perplexity:  { name: 'Perplexity', icon: '🔍', color: '#20808d' },
};

// ─── Generate the shared 10-prompt pool via backend ───────────────────────
const generateLLMQuestions = async (brand, keywords, city) => {
  const cacheKey = `llmQuestions_${brand}_${city}_${keywords.slice(0, 5).join('_')}`.replace(/\s/g, '');

  try {
    const cached = localStorage.getItem(cacheKey);
    if (cached) {
      const { ts, questions } = JSON.parse(cached);
      if (Date.now() - ts < CACHE_TTL && questions?.length) {
        return questions;
      }
    }
  } catch {}

  try {
    const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/generate-questions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Secret-Token': process.env.REACT_APP_SECRET_TOKEN || '',
      },
      body: JSON.stringify({ brand, keywords, city: city || '', pool_size: 10 }),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const { questions } = await res.json();
    if (questions?.length) {
      localStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), questions }));
      return questions;
    }
  } catch (e) {
    console.warn('LLM question generation failed, using template fallback:', e);
  }
  return null; // backend falls back to round-robin templates
};

// ─── Gemini wrapper (used only for the narrative insight box) ────────────
const genAI = GEMINI_API_KEY ? new GoogleGenerativeAI(GEMINI_API_KEY) : null;
const callGemini = async (prompt) => {
  if (!genAI) throw new Error('REACT_APP_GEMINI_API_KEY not set in .env');
  const model = genAI.getGenerativeModel({ model: 'gemini-2.5-flash' });
  const result = await model.generateContent(prompt);
  const response = await result.response;
  return response.text();
};

// ─── AI Insight Box ─────────────────────────────────────────────────────
const AIInsightBox = ({ prompt, cacheKey, title = 'AI Visibility Insight', autoGenerate = true }) => {
  const [aiText, setAiText] = useState('');
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError, setAiError] = useState('');
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const generatedRef = useRef(false);

  useEffect(() => () => window.speechSynthesis.cancel(), []);

  useEffect(() => {
    if (!cacheKey) return;
    generatedRef.current = false;
    const loadOrGenerate = async () => {
      try {
        const cached = localStorage.getItem(`ai_insight_${cacheKey}`);
        if (cached) {
          const { ts, text } = JSON.parse(cached);
          if (Date.now() - ts < INSIGHT_TTL && text) {
            setAiText(text);
            return;
          }
        }
      } catch {}
      if (autoGenerate && !generatedRef.current) {
        generatedRef.current = true;
        await generate();
      }
    };
    loadOrGenerate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cacheKey, prompt]);

  const generate = async () => {
    if (!prompt) return;
    setAiLoading(true);
    setAiError('');
    try {
      const text = await callGemini(prompt);
      setAiText(text);
      if (cacheKey) {
        localStorage.setItem(`ai_insight_${cacheKey}`, JSON.stringify({ ts: Date.now(), text }));
      }
    } catch (e) {
      setAiError('Could not generate insight. Check your API key.');
      console.error(e);
    } finally {
      setAiLoading(false);
    }
  };

  const togglePlayback = () => {
    const synth = window.speechSynthesis;
    if (isPlaying) {
      synth.pause();
      setIsPlaying(false);
      setIsPaused(true);
    } else if (isPaused && synth.paused) {
      synth.resume();
      setIsPlaying(true);
      setIsPaused(false);
    } else {
      synth.cancel();
      const utterance = new SpeechSynthesisUtterance(aiText.replace(/<[^>]*>/g, ''));
      utterance.lang = 'en-IN';
      utterance.onend = () => { setIsPlaying(false); setIsPaused(false); };
      utterance.onerror = () => { setIsPlaying(false); setIsPaused(false); };
      synth.speak(utterance);
      setIsPlaying(true);
      setIsPaused(false);
    }
  };

  return (
    <div className="insight-box" id="insight-box-9">
      <div className="insight-header">
        <div className="insight-title">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path d="M12 2a7 7 0 00-7 7c0 2.6 1.4 4.9 3.5 6.2V17a1 1 0 001 1h5a1 1 0 001-1v-1.8C17.6 13.9 19 11.6 19 9a7 7 0 00-7-7zm2 17h-4v1a1 1 0 001 1h2a1 1 0 001-1v-1z" />
          </svg>
          {title}
        </div>
        {aiText && !aiLoading && (
          <button className="play-btn" onClick={togglePlayback}>
            <svg viewBox="0 0 24 24" width="12" height="12">
              {isPlaying
                ? <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                : <path d="M8 5v14l11-7z" />}
            </svg>
            {isPlaying ? 'Pause' : 'Play'}
          </button>
        )}
      </div>
      {aiLoading && <div style={{ fontSize: 13, color: '#6B4FA0' }}>Generating AI insight…</div>}
      {aiError && !aiLoading && <div style={{ fontSize: 12, color: '#c62828' }}>{aiError}</div>}
      {aiText && !aiLoading && <div className="insight-text" id="insight-text-9">{aiText}</div>}
      {!aiText && !aiLoading && !aiError && (
        <div style={{ fontSize: 12, color: '#aaa', fontStyle: 'italic' }}>AI insight will appear here shortly.</div>
      )}
    </div>
  );
};

// ── Overall insight prompt, built from all 4 platforms + SOV + sentiment ──
const buildOverallPrompt = (brandName, keywordCoverage, platformsData, summary) => {
  const line = (p) =>
    `${p.name} Visibility Score: ${p.overallScore}/100 | Mentions: ${p.mentionedCount}/${p.totalPrompts}`;

  const avgScore = Math.round(
    platformsData.reduce((sum, p) => sum + p.overallScore, 0) / Math.max(platformsData.length, 1)
  );

  return `You are a senior digital strategist specialising in AI search visibility.
Professional, business-appropriate language. No bullet points. Maximum 3 sentences.

Brand: ${brandName}
Keywords covered by the shared prompt pool: ${keywordCoverage}

${platformsData.map(line).join('\n')}
Composite AI Visibility Score: ${avgScore}/100
Share of Voice: ${summary?.share_of_voice?.brand_share_pct ?? 0}%
Sentiment split — Positive: ${summary?.sentiment_breakdown?.positive_pct ?? 0}% · Neutral: ${summary?.sentiment_breakdown?.neutral_pct ?? 0}% · Negative: ${summary?.sentiment_breakdown?.negative_pct ?? 0}%

Provide a professional cross-platform assessment of this brand's AI search visibility. Identify the platform representing the highest priority for improvement. Conclude with the strategic implication of the current composite score and share of voice as AI-driven discovery increasingly shapes purchasing behaviour.`;
};

// ─────────────────────────────────────────────────────────────────────────
// Main Component
// ─────────────────────────────────────────────────────────────────────────
const AIVisibilityPage = ({
  brandName,
  pillarKeywords: propsKeywords,
  competitors: propsCompetitors,
  location,
  onContinue,
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [pillarKeywords, setPillarKeywords] = useState([]);
  const [aiData, setAiData] = useState(null);
  const [activeTab, setActiveTab] = useState('chatgpt');
  const [llmQuestions, setLlmQuestions] = useState(null);

  const isFetching = useRef(false);
  const llmQuestionsRef = useRef(null);
  const auditFiredRef = useRef(false);

  // ── Resolve keywords (props → localStorage) and kick off shared-pool gen ──
  useEffect(() => {
    const fromProps = Array.isArray(propsKeywords) ? propsKeywords.filter(Boolean) : [];
    let resolvedKeywords = [];
    let resolvedCity = location || '';

    if (fromProps.length > 0) {
      resolvedKeywords = fromProps;
      setPillarKeywords(fromProps);
    } else {
      try {
        const stored = localStorage.getItem('auditFormData');
        if (stored) {
          const formData = JSON.parse(stored);
          const kw = (formData.pillarKeywords || []).filter(Boolean);
          if (kw.length) {
            resolvedKeywords = kw;
            if (!resolvedCity) resolvedCity = formData.locations?.[0]?.city || '';
            setPillarKeywords(kw);
          } else {
            setError('No pillar keywords found. Please complete step 1 first.');
            setLoading(false);
          }
        } else {
          setError('No audit data found. Please start the audit from step 1.');
          setLoading(false);
        }
      } catch {
        setError('Failed to load audit data.');
        setLoading(false);
      }
    }

    if (resolvedKeywords.length && brandName) {
      generateLLMQuestions(brandName, resolvedKeywords, resolvedCity).then((qs) => {
        if (qs) setLlmQuestions(qs);
      });
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(propsKeywords)]);

  const cleanDomain = (url) =>
    url?.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();

  
  // ── Fire the ONE shared-pool audit across all keywords at once ──────────
  const fetchAIVisibility = useCallback(async (forceRefresh = false) => {
    if (!pillarKeywords.length || !brandName) return;

    const stored = localStorage.getItem('auditFormData');
      let websiteUrl = '', locationCity = location || '';
      let rawCompetitors = Array.isArray(propsCompetitors) ? propsCompetitors : [];

      try {
        if (stored) {
          const formData = JSON.parse(stored);
          websiteUrl = formData.websiteUrl || '';
          if (!locationCity) locationCity = formData.locations?.[0]?.city || '';
          if (!rawCompetitors.length) rawCompetitors = formData.competitors || [];
        }
      } catch (e) {
        console.warn('Failed to parse auditFormData', e); // don't swallow silently
      }

      // Normalize to plain domain strings — matches the shape used elsewhere (autoDiscover, buildFormData)
      const competitorNames = rawCompetitors
      .map(c => {
        if (typeof c === 'string') return c;
        return c.name || (c.website ? cleanDomain(c.website) : null);
      })
      .filter(Boolean);

    const domain = cleanDomain(websiteUrl) || brandName.toLowerCase().replace(/\s/g, '');
    const brandSlug = brandName.toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 20);
    const kwSlug = pillarKeywords.slice(0, 5).join('|').toLowerCase().replace(/[^a-z0-9|]/g, '');
    const cacheKey = `aiVisibility_${domain}_${brandSlug}_${kwSlug}`;
    const now = Date.now();

    if (!forceRefresh) {
      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        try {
          const { timestamp, data } = JSON.parse(cached);
          if (now - timestamp < CACHE_TTL) {
            setAiData(data);
            setLoading(false);
            return;
          }
        } catch {}
      }
    }

    if (isFetching.current && !forceRefresh) return;
    isFetching.current = true;
    setLoading(true);
    setError('');
     console.log("llm quesiton",llmQuestions) 
    try {
      const response = await auditAPI.aiVisibility({
        domain,
        platforms: PLATFORM_ORDER,
        keywords: pillarKeywords,       // ALL tracked keywords — round-robin pool built server-side
        brand: brandName,
        competitors: competitorNames,
        location: locationCity,
        industry: '',
        force_refresh: forceRefresh,
        llm_questions: llmQuestionsRef.current || undefined,
      });

      const result = response?.data?.data || response?.data || response;
      if (!result) throw new Error('Empty response');

      const platformData = result.platform_results || {};
      const summary = result.summary || {};
      const promptPool = result.prompt_pool || [];

      const platformsArray = PLATFORM_ORDER
        .filter((id) => platformData[id])
        .map((id) => {
          const p = platformData[id];
          return {
            id,
            name: platformConfig[id]?.name || p.display_name || id,
            icon: platformConfig[id]?.icon || p.icon || '?',
            borderColor: platformConfig[id]?.color || p.color || '#6b7280',
            overallScore: p.overall_score || 0,
            visible: p.visible || 'Not Found',
            badgeClass: p.visible === 'Visible' ? 'aiv-y' : (p.visible === 'Partial' ? 'aiv-p' : 'aiv-n'),
            mentionedCount: p.n_mentioned || 0,
            totalPrompts: p.total_questions || promptPool.length || 10,
            avgRank: p.avg_rank,
            dominantTone: p.dominant_tone,
            questions: (p.question_results || []).map((q) => ({
              id: q.q_index,
              text: q.question,
              mentioned: q.mentioned || false,
              rank: q.rank || null,
              sentiment: q.tone ? q.tone.charAt(0).toUpperCase() + q.tone.slice(1) : 'Neutral',
              snippet: q.snippet || '',
            })),
          };
        });

      const finalData = {
        summary: {
          aiVisibilityScore: Math.round(summary.brand_avg_score || 0),
          platformsVisibleOn: summary.brand_visible_on || 0,
          visiblePlatforms: summary.visible_platforms || [],
          platformsTested: summary.platforms_tested || platformsArray.length,
          avgMentionPosition: summary.avg_mention_position || '—',
          shareOfVoice: summary.share_of_voice || null,
          sentimentBreakdown: summary.sentiment_breakdown || null,
          totalCombinations: summary.total_combinations || 0,
          lastChecked: new Date().toLocaleString(),
        },
        platforms: platformsArray,
        promptPool,
        insight: result.insight || null,
      };

      localStorage.setItem(cacheKey, JSON.stringify({ domain, timestamp: Date.now(), data: finalData }));
      setAiData(finalData);
    } catch (err) {
      console.error(err);
      setError(err.message || 'Failed to fetch AI visibility data.');
    } finally {
      isFetching.current = false;
      setLoading(false);
    }
  }, [brandName, location, pillarKeywords, propsCompetitors]);

  useEffect(() => {
    llmQuestionsRef.current = llmQuestions;
  }, [llmQuestions]);

  // Fires audit once the shared pool is ready, or after an 8s timeout fallback
  useEffect(() => {
    if (!pillarKeywords.length || aiData || auditFiredRef.current) return;

    if (llmQuestions) {
      auditFiredRef.current = true;
      fetchAIVisibility(false);
      return;
    }

    const timer = setTimeout(() => {
      if (!auditFiredRef.current) {
        auditFiredRef.current = true;
        fetchAIVisibility(false);
      }
    }, 8000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pillarKeywords, aiData]);

  useEffect(() => {
    if (!llmQuestions || !pillarKeywords.length || aiData || auditFiredRef.current) return;
    auditFiredRef.current = true;
    fetchAIVisibility(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [llmQuestions]);

  const activePlatform = aiData?.platforms?.find((p) => p.id === activeTab) || null;
  const activePlatformScore = activePlatform?.overallScore || 0;

  if (loading) {
    return (
      <div className="card" id="card-9">
        <div className="eyebrow">AI Visibility</div>
        <h2 className="ctitle">AI Search Visibility</h2>
        <p className="cdesc">Is your brand being recommended by AI tools when customers search for your keywords? Share of voice and sentiment — the full picture, before we get into anything else.</p>
        <div className="ai-fetch show">
          <div className="spinner" />
          <span>Checking AI visibility across ChatGPT, Gemini, Claude &amp; Perplexity…</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card" id="card-9">
        <div className="eyebrow">AI Visibility</div>
        <h2 className="ctitle">AI Search Visibility</h2>
        <p className="cdesc" style={{ color: '#C0392B' }}>{error}</p>
        <button className="btn" onClick={() => fetchAIVisibility(true)}>Retry</button>
      </div>
    );
  }

  if (!aiData?.platforms) {
    return (
      <div className="card" id="card-9">
        <div className="eyebrow">AI Visibility</div>
        <h2 className="ctitle">AI Search Visibility</h2>
        <p className="cdesc">No AI visibility data available.</p>
      </div>
    );
  }

  const { summary, platforms, promptPool } = aiData;
  const sov = summary.shareOfVoice;
  const sentiment = summary.sentimentBreakdown;

  return (
    <div className="card" id="card-9">
      <div className="eyebrow">AI Visibility</div>
      <h2 className="ctitle">AI Search Visibility</h2>
      <p className="cdesc">Is your brand being recommended by AI tools when customers search for your keywords? Share of voice and sentiment — the full picture, before we get into anything else.</p>

      <div className="ai-wrap show">
        {/* Coverage note — replaces the old per-keyword dropdown; the pool now spans ALL keywords */}
        <div className="ai-kw-row">
          <span className="ai-kw-label">Coverage</span>
          <span className="ai-coverage-note">
            {promptPool?.length || 0} shared prompts across {pillarKeywords.length} keyword{pillarKeywords.length !== 1 ? 's' : ''} · {summary.totalCombinations} prompt/tool combinations tested
          </span>
        </div>

        {/* Score cards per platform */}
        <div className="ai-score-row">
          {platforms.map((p) => (
            <div key={p.id} className="ai-score-card" style={{ borderTop: `2px solid ${p.borderColor}` }}>
              <div className="ai-tool-logo">{p.icon}</div>
              <div className="ai-tool-name">{p.name}</div>
              <div className="ai-vis-score" style={{ color: p.borderColor }}>{p.overallScore}</div>
              <div className="ai-mention-count">{p.mentionedCount}/{p.totalPrompts} mentions</div>
            </div>
          ))}
        </div>

        {/* Platform tabs */}
        <div className="ai-tabs">
          {PLATFORM_ORDER.map((pid) => {
            const p = platforms.find((pl) => pl.id === pid);
            if (!p) return null;
            return (
              <button
                key={pid}
                className={`ai-tab ${activeTab === pid ? 'active' : ''}`}
                onClick={() => setActiveTab(pid)}
              >
                <span style={{ fontSize: 14 }}>{p.icon}</span> {p.name}
              </button>
            );
          })}
        </div>

        {/* Visibility score bar */}
        <div className="ai-vis-bar-wrap">
          <span className="ai-vis-bar-label">{activePlatform?.name} · AI Visibility Score</span>
          <div className="ai-vis-bar-track">
            <div className="ai-vis-bar-fill" style={{ width: `${activePlatformScore}%` }} />
          </div>
          <span className="ai-vis-score-num">{activePlatformScore}/100</span>
        </div>

        {/* Prompts list (shared top-10 pool) */}
        <div className="ai-panel" id="ai-prompt-panel">
          <div className="ai-panel-hdr">
            <span className="ai-panel-title">Top 10 Prompts Tested</span>
            <span className="ai-panel-sub">for {activePlatform?.name}</span>
          </div>
          <div className="prompt-list">
            {activePlatform?.questions.map((q, i) => (
              <div key={i} className="prompt-row">
                <div className="prompt-top">
                  <div className="prompt-num">{i + 1}</div>
                  <div className="prompt-text">"{q.text}"</div>
                </div>
                <div className="prompt-meta">
                  <span className={`pmeta-badge ${q.mentioned ? 'pmeta-mentioned' : 'pmeta-not'}`}>
                    {q.mentioned ? '✓ Mentioned' : '✗ Not Mentioned'}
                  </span>
                  {q.mentioned && q.rank && <span className="pmeta-pos">Position #{q.rank}</span>}
                  {q.mentioned && q.sentiment && (
                    <span className={`pmeta-sent-${q.sentiment.toLowerCase()}`}>{q.sentiment}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Share of Voice */}
        {sov && (
          <div className="ai-panel" id="ai-sov-panel">
            <div className="ai-panel-hdr">
              <span className="ai-panel-title">Share of Voice vs Competitors</span>
              <span className="ai-panel-sub">across all {sov.total_combinations} prompt/tool combinations</span>
            </div>
            <div className="sov-list">
              <div className="sov-row sov-row-brand">
                <span className="sov-name">{brandName}</span>
                <div className="sov-bar-track">
                  <div className="sov-bar-fill" style={{ width: `${sov.brand_share_pct}%` }} />
                </div>
                <span className="sov-pct">{sov.brand_share_pct}%</span>
              </div>
              {Object.entries(sov.competitor_shares || {}).map(([name, pct]) => (
                <div key={name} className="sov-row">
                  <span className="sov-name">{name}</span>
                  <div className="sov-bar-track">
                    <div className="sov-bar-fill sov-bar-competitor" style={{ width: `${pct}%` }} />
                  </div>
                  <span className="sov-pct">{pct}%</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Sentiment Breakdown */}
        {sentiment && (
          <div className="ai-panel" id="ai-sent-panel">
            <div className="ai-panel-hdr">
              <span className="ai-panel-title">Sentiment Breakdown</span>
              <span className="ai-panel-sub">{sentiment.total_mentions} total mentions analysed</span>
            </div>
            <div className="sent-bar-track">
              <div className="sent-bar-pos" style={{ width: `${sentiment.positive_pct}%` }} />
              <div className="sent-bar-neu" style={{ width: `${sentiment.neutral_pct}%` }} />
              <div className="sent-bar-neg" style={{ width: `${sentiment.negative_pct}%` }} />
            </div>
            <div className="sent-legend">
              <span className="sent-legend-pos">● Positive {sentiment.positive_pct}%</span>
              <span className="sent-legend-neu">● Neutral {sentiment.neutral_pct}%</span>
              <span className="sent-legend-neg">● Negative {sentiment.negative_pct}%</span>
            </div>
          </div>
        )}

        {/* Overall AI Insight */}
        <AIInsightBox
          title="AI Visibility Insight"
          cacheKey={`ai_overall_${brandName.replace(/\s/g, '')}_${pillarKeywords.join('_').replace(/\s/g, '')}`}
          prompt={buildOverallPrompt(brandName, pillarKeywords.join(', '), platforms, {
            share_of_voice: sov,
            sentiment_breakdown: sentiment,
          })}
          autoGenerate={!!GEMINI_API_KEY}
        />
      </div>

      <button className="btn" onClick={onContinue} style={{ marginTop: 20 }}>
        Continue to Domain &amp; Backlink Comparison
        <svg viewBox="0 0 24 24" fill="white">
          <path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z" />
        </svg>
      </button>
    </div>
  );
};

export default AIVisibilityPage;